import { HeadPosition } from 'modules/onboarding/common/components';

import { useHeadPosition } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const HeadPositionStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    submitLoading,
    submitDisabled,
    files,
    onSubmit,
    onAddFiles,
    onRemoveFile,
    goToBack,
  } = useHeadPosition();

  const { step } = useOnboardingContext();

  return (
    <HeadPosition
      onlyPositionInCompany
      bodies={[]}
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
